module.exports = __webpack_public_path__ + "static/media/logo-white.9ac051fb.svg";